module.exports = __webpack_public_path__ + "img/collection-engagementRingsDainty.dc119c8.jpg";